<div class="center" style="max-height: 80vh;" fusePerfectScrollbar>
    <div class="content-card">
        <div class="content-header">
            <div class="h2 secondary-text">
                <mat-icon>room</mat-icon> {{'SHIFT_ADDING_FORM'|translate}}
            </div>
            <hr>
        </div>
        <div class="my-20">
            <mat-vertical-stepper [linear]="true" #stepper>
                <mat-step [stepControl]="formCar.control">
                    <form #formCar="ngForm">
                        <ng-template matStepLabel>{{'CAR'|translate}} {{carSelect==null?('CHOOSE'|translate):('CHOSEN'|translate)}}.</ng-template>
                        <mat-form-field style="margin-top: 24px;" appearance="outline" floatLabel="always"
                            class="w-100-p">
                            <mat-label>{{'CAR'|translate}}</mat-label>
                            <mat-select [(ngModel)]="shift.carId" (ngModelChange)="carChange()"
                                placeholder="{{'SELECT_CAR'|translate}}" required name="selectcar">
                                <mat-option *ngFor="let item of carList" [value]="item.id">
                                    {{item.plate}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div>
                            <button mat-button matStepperNext>{{'NEXT'|translate}}</button>
                        </div>
                    </form>
                </mat-step>
                <mat-step [stepControl]="formContainer">
                    <form #formContainer="ngForm">
                        <ng-template matStepLabel>{{'SELECT_THE_CONTAINERS_TO_BE_ADDED_TO_THE_ROUTE'|translate}}</ng-template>
                        <div class="containerContent fuse-navy-700">

                            <div fxLayout="column" fxLayoutAlign="center start">
                                <div style="width: 100%;" class="content-header">
                                    <div class="h2 secondary-text p-20">
                                        {{'ADD_CONTAINER'|translate}}/{{'REMOVE'|translate}}
                                    </div>
                                    <hr>
                                </div>
                                <div fxLayout="row" fxLayout.lt-sm="column" style="width: 100%;"
                                    fxLayoutAlign="space-between start">
                                    <div class="containerChange">
                                        <div *ngFor="let item of containerList" fxLayout="row"
                                            fxLayoutAlign="start center">
                                            <button mat-icon-button color="accent" (click)="containerChange(item)"
                                                aria-label="Example icon button with a menu icon">
                                                <mat-icon>add</mat-icon>
                                            </button>
                                            <span>{{item.streetDesc}}</span>
                                            <mat-divider></mat-divider>
                                        </div>
                                    </div>
                                    <hr style="width: 100%;" [fxHide]="true" [fxHide.lt-sm]="false">
                                    <div class="containerChange">
                                        <div *ngFor="let item of shift.containers" fxLayout="row"
                                            fxLayoutAlign="start center">
                                            <button mat-icon-button color="accent" (click)="containerUnChange(item)"
                                                aria-label="Example icon button with a menu icon">
                                                <mat-icon>cancel</mat-icon>
                                            </button>
                                            <span>{{item.streetDesc}}</span>
                                            <mat-divider></mat-divider>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div>
                            <button mat-button matStepperPrevious>{{'BACK'|translate}}</button>
                            <button mat-button matStepperNext>{{'NEXT'|translate}}</button>
                        </div>
                    </form>
                </mat-step>
                <mat-step [stepControl]="shiftInfo">
                    <form #shiftInfo="ngForm" (keydown.enter)="$event.preventDefault()">
                        <ng-template matStepLabel>{{'SHIFT_INFORMATION'|translate}}</ng-template>
                        <div style="margin-top: 24px;" fxLayout="row wrap" fxLayoutAlign="space-between center">

                            <mat-form-field fxFlex.gt-xs="50" fxFlex="100" appearance="outline" floatLabel="always"
                                class="pr-20">
                                <mat-label>{{'SHIFT'|translate}} {{'START_DATE'|translate}}</mat-label>
                                <input matInput [ngxMatDatetimePicker]="startpicker" name="startpicker"
                                    placeholder="{{'SHIFT'|translate}} {{'START_DATE'|translate}}" [(ngModel)]="shift.startDate" required>
                                <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
                                <ngx-mat-datetime-picker #startpicker>
                                    <!-- Custom icon or text of Apply icon -->
                                    <ng-template>
                                        <!-- <mat-icon>star</mat-icon> -->
                                        <span>OK</span>
                                    </ng-template>
                                </ngx-mat-datetime-picker>
                            </mat-form-field>

                            <mat-form-field fxFlex.gt-xs="50" fxFlex="100" appearance="outline" floatLabel="always"
                                class="pr-20">
                                <mat-label>{{'SHIFT'|translate}} {{'END_DATE'|translate}}</mat-label>
                                <input matInput [ngxMatDatetimePicker]="endpicker" placeholder="{{'SHIFT'|translate}} {{'END_DATE'|translate}}"
                                    name="endpicker" [(ngModel)]="shift.endDate" required>
                                <mat-datepicker-toggle matSuffix [for]="endpicker"></mat-datepicker-toggle>
                                <ngx-mat-datetime-picker #endpicker>
                                    <!-- Custom icon or text of Apply icon -->
                                    <ng-template>
                                        <!-- <mat-icon>star</mat-icon> -->
                                        <span>{{'OK'|translate}}</span>
                                    </ng-template>
                                </ngx-mat-datetime-picker>
                            </mat-form-field>

                            <mat-form-field fxFlex="100" appearance="outline" floatLabel="always" class="pr-20">
                                <mat-label>{{'DESCRIPTION'|translate}}</mat-label>
                                <textarea matInput name="description-textarea" [(ngModel)]="shift.description"
                                    required></textarea>
                            </mat-form-field>

                            <mat-checkbox class="my-20" [(ngModel)]="shift.status" name="shiftCheckbox">{{'SHIFT_STATUS'|translate}}
                            </mat-checkbox>
                        </div>

                        <!-- Personel Ekleme    

                            <mat-form-field fxFlex="100" appearance="outline" floatLabel="always" class="pr-20">
                                <mat-label>Personel Ad Soyad</mat-label>
                                <input matInput placeholder="Ad Soyad" (keyup.enter)="personelAdd($event)"
                                    name="personelName" required>
                            </mat-form-field>
                            <div *ngIf="personelArray.length!=0" class="personelChipsList">
                                <mat-chip-list #chipList>
                                    <mat-chip *ngFor="let item of personelArray" (removed)="remove(item)">
                                        {{item}}
                                        <mat-icon matChipRemove>cancel</mat-icon>
                                    </mat-chip>
                                </mat-chip-list>
                            </div>

                        -->
                        <div>
                            <button mat-button matStepperPrevious>{{'BACK'|translate}}</button>
                            <button mat-button (click)="submit(shiftInfo)">{{'CREATE'|translate}}</button>
                        </div>
                    </form>
                </mat-step>
            </mat-vertical-stepper>
        </div>
    </div>
</div>